import type {ButtonProps} from 'baseui/button'
import {forwardRef} from 'react'
import tw from 'twin.macro'
import {Button} from 'baseui/button'

export const ButtonWrapper = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const {children, ...params} = props
    return (
      <Button
        ref={ref}
        overrides={{
          BaseButton: {
            style: () => ({
              ...tw`font-secondary font-medium`,
              width: '100%',
              backgroundColor: '#36FAD7',
              fontSize: '14px',
              lineHeight: '18px',
              paddingTop: '11px',
              paddingBottom: '11px',
              color: '#000000',
              ':disabled': {color: '#fff', backgroundColor: '#b5b5b5'},
            }),
          },
        }}
        {...params}
      >
        {children}
      </Button>
    )
  }
)

ButtonWrapper.displayName = 'ButtonWrapper'
